import axios from '@axios';
import HelperService from './HelperService';

const helperService = new HelperService();
const base = '/api/v1/purple-post/purple-post-digital-reply';

export default {
  getAll(filters) {
    const queryString = helperService.buildSearchQueryString(filters);
    return axios.get(`${base}/prison${queryString}`);
  },
  getRepliesByPostId(postId) {
    return axios.get(`${base}/post/${postId}`);
  },
  getSingleReply(id) {
    return axios.get(`${base}/reply/${id}`);
  },
  approvePost(id) {
    return axios.post(`${base}/approve/${id}`);
  },
  rejectPost(id, rejectionReason) {
    return axios.post(`${base}/reject/${id}`, { rejection_reason: rejectionReason });
  },
  translatePost(id, languageCode = 'en') {
    return axios.post(`${base}/translate/${id}`, { desired_language: languageCode });
  },
};
